import { render, staticRenderFns } from "./LevelSelector.vue?vue&type=template&id=348b952e&scoped=true"
import script from "./LevelSelector.vue?vue&type=script&lang=ts"
export * from "./LevelSelector.vue?vue&type=script&lang=ts"
import style0 from "./LevelSelector.vue?vue&type=style&index=0&id=348b952e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348b952e",
  null
  
)

export default component.exports